import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import Header from '../Header/Header.tsx';
import Footer from '../Footer/Footer.tsx';
import './Layout.css';

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="layout">
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header />
      <main id="main" className="layout__main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
